/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Switchlanguage1Inputs */

const en_switchlanguage1 = /** @type {(inputs: Switchlanguage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Switch language`)
};

const de_switchlanguage1 = /** @type {(inputs: Switchlanguage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprache wechseln`)
};

/**
* | output |
* | --- |
* | "Switch language" |
*
* @param {Switchlanguage1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const switchlanguage1 = /** @type {((inputs?: Switchlanguage1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Switchlanguage1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_switchlanguage1(inputs)
	return de_switchlanguage1(inputs)
});
export { switchlanguage1 as "switchLanguage" }